<style lang="stylus" rel="stylesheet/stylus">
  @import 'common/stylus/index'
  @import 'common/stylus/variable'
  @import 'common/stylus/common'
  .containerBox {
    min-height: 100%;
    width: 100%;
    background: $color-page
  }
  .mint-toast {
    z-index: 2050;
  }
</style>

<template>
  <div class="containerBox" @focusout="inputBlur" @focusin="inputFocus">
    <welcome v-if="welcomeImgVisible"></welcome>
    <keep-alive>
      <router-view v-if="!$route.meta.keep"></router-view>
    </keep-alive>
    <router-view v-if="$route.meta.keep"></router-view>
    <take-cards-modal :visible="takeCardsModalVisible"></take-cards-modal>
  </div>
</template>

<script>
  import {mapState, mapMutations} from 'vuex';
  import takeCardsModal from 'src/components/common/TakeCardsModal'
  import welcome from 'src/components/common/Welcome'

  export default {
    metaInfo () {
      return {
        title: this.$route.path === '/' ? '' : (this.$route.meta.title ? this.$route.meta.title : '点餐')
      }
    },
    data() {
      return {
        title: '',
        inputTimer: 0 // input blur定时器
      }
    },
    components: {
      takeCardsModal,
      welcome
    },
    computed: {
      ...mapState(['popStateListener', 'takeCardsModalVisible', 'welcomeImgVisible'])
    },
    methods: {
      ...mapMutations(['deletePopStateListener', 'addPopStateListener']),
      /**
       * 解决：IOS键盘收起后，弹出框内的点击事件错位
       * 输入框失去焦点后滚动到原始位置
       * @param e
       */
      inputBlur(e) {
        // 首先，判断触发事件的目标元素是否是input输入框，我们只关注输入框的行为。
        if (e && e.target && e.target.tagName && e.target.tagName.toLowerCase() === 'input') {
          // 输入框失去焦点，要把IOS键盘推出页面的滚动部分还原。即将页面滚动到视窗顶部对齐
          this.inputTimer = setTimeout(() => {
            window.scrollTo(0, 0);
          }, 100);
        }
      },
      /**
       * 防止input之间切换时触发blur事件的滚动，引起抖动
       * @param e
       */
      inputFocus(e) {
        // 如果focus，则移除上一个输入框的timer
        if (e && e.target && e.target.tagName && e.target.tagName.toLowerCase() === 'input') {
          clearTimeout(this.inputTimer);
        }
      }
    },
    created () {
    },
    mounted () {
      // 全屏子组件监听手机返回按键(例如从菜品详情返回到菜例列表页，而不是返回到上级路由)
      let self = this;
      window.addEventListener('popstate', function(e) {
        if (self.popStateListener.length > 0) {
          self.deletePopStateListener();
        }
        return false;
      }, false);
      // 弹出键盘 窗口缩放
      let windowHeight = window.innerHeight;
      window.addEventListener('resize', function() {
        if (window.innerHeight === windowHeight) {  // 收起键盘
          document.activeElement.blur();
//          setTimeout(() => {
//            let scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
//            window.scrollTo(0, Math.max(scrollHeight - 1, 0));
//          }, 100);
        }
      });
    }
  }

</script>



// WEBPACK FOOTER //
// src/App.vue